import { Error } from '../../../../../ErrorHandling';
import { Resource } from '../../../../../Resource/Types';

interface Ready {
  kind: 'ready';
}

interface Updating {
  kind: 'updating';
}

export interface Succeeded {
  kind: 'succeeded';
  userCount: number;
  reclaimedLicenseCount: number;
}

export const ready = (): Ready => ({
  kind: 'ready',
});

export const updating = (): Updating => ({
  kind: 'updating',
});

export const succeeded = (userCount: number, reclaimedLicenseCount: number): Succeeded => ({
  kind: 'succeeded',
  userCount,
  reclaimedLicenseCount,
});

export interface BulkLicensesReclaimed {
  userCount: number;
  reclaimedLicenseCount: number;
}

export type BulkLicensesReclaimedResource = Resource<BulkLicensesReclaimed>;

export type State = Ready | Updating | Succeeded | Error;
